import { StructuredListWrapper, StructuredListHead, StructuredListRow, StructuredListCell, StructuredListBody, UnorderedList, ListItem } from 'carbon-components-react';
import React from 'react';
export default {
  StructuredListWrapper,
  StructuredListHead,
  StructuredListRow,
  StructuredListCell,
  StructuredListBody,
  UnorderedList,
  ListItem,
  React
};